module.exports = new __parcel__URL__("10380037-1.807f7bab.png").toString();